import React from 'react';
import './Legal.css';
import Header from '../Shared/Header/Header';
import Footer from '../Shared/Footer/Footer';
import SubHeader from '../Shared/SubHeader';

const PrivacyPolicy = () => {
    return (
        <>
            <Header />
            <SubHeader title="Privacy Policy" subtitle="How we collect, use, and protect your data." />
            
            <section className="legal-section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="legal-card">
                                <p className="last-updated">Last Updated: October 2023</p>

                                <h3>1. Introduction</h3>
                                <p>MediCare Plus Health Solution ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how your personal information is collected, used, and disclosed by MediCare Plus Health Solution.</p>
                                
                                <h3>2. Information We Collect</h3>
                                <p>We collect information that you provide directly to us, such as when you create an account, update your profile, use our services, or communicate with us.</p>
                                <ul>
                                    <li><strong>Personal Information:</strong> Name, email address, phone number, date of birth, and health-related information you choose to provide.</li>
                                    <li><strong>Usage Data:</strong> We may also collect information that your browser sends whenever you visit our website, such as your computer's Internet Protocol (IP) address, browser type, browser version, and the pages of our Service that you visit.</li>
                                </ul>

                                <h3>3. How We Use Your Information</h3>
                                <p>We use the information we collect in various ways, including to:</p>
                                <ul>
                                    <li>Provide, operate, and maintain our website and services</li>
                                    <li>Improve, personalize, and expand our website</li>
                                    <li>Understand and analyze how you use our website</li>
                                    <li>Develop new products, services, features, and functionality</li>
                                    <li>Communicate with you, either directly or through one of our partners, including for customer service and to provide you with updates.</li>
                                </ul>

                                <h3>4. Data Security</h3>
                                <p>The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security. All patient data is encrypted and stored in compliance with standard healthcare regulations.</p>

                                <h3>5. Sharing Your Information</h3>
                                <p>We do not sell, trade, or rent Users' personal identification information to others. We may share generic aggregated demographic information not linked to any personal identification information regarding visitors and users with our business partners, trusted affiliates, and advertisers for the purposes outlined above.</p>

                                <h3>6. Your Data Protection Rights</h3>
                                <p>Depending on your location, you may have the following rights regarding your personal data:</p>
                                <ul>
                                    <li>The right to access, update or to delete the information we have on you.</li>
                                    <li>The right of rectification. You have the right to have your information rectified if that information is inaccurate or incomplete.</li>
                                    <li>The right to object. You have the right to object to our processing of your Personal Data.</li>
                                    <li>The right of restriction. You have the right to request that we restrict the processing of your personal information.</li>
                                </ul>

                                <h3>7. Changes to This Privacy Policy</h3>
                                <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes.</p>

                                <h3>8. Contact Us</h3>
                                <p>If you have any questions about this Privacy Policy, please contact us at privacy@medicareplus.com.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default PrivacyPolicy;
